<template>
  <!-- Covid19 is a special event - do not display it -->
  <div class="event-details" v-if="event && !event.isCovid19()">
    <div class="event-details-header">
      <div class="event-header">
        <div class="icon" :style="{ backgroundImage: `url(${event.categoryRef.icon})` }"></div>
        <h4>
          {{
            $language.current
              | translateToCurrentLang(event.categoryRef.nameEs, event.categoryRef.nameEn)
          }}
        </h4>
      </div>
      <p class="description">
        <span v-html="getEventDescription(event)"></span>
      </p>
    </div>
    <md-field v-if="organizationDetails.enableWhenItHappenedEventQuestion" class="input-field">
      <h5 v-translate>When it happened:</h5>
      <md-input
        v-model="event.dateOccurred"
        :placeholder="$gettext('MM/YYYY')"
        :style="{ borderBottom: '1px solid gray' }"
        @blur="$emit('fieldBlur')"
      ></md-input>
    </md-field>
    <div v-for="question in event.questions" :key="question.id">
      <Question class="question" :question="question" @answer-changed="onAnswerChanged($event)" />
    </div>
  </div>
</template>

<script>
import Question from '@/components/survey/Question'
import { mapState } from 'vuex'
import utils from '@/services/utils'

export default {
  name: 'EventComponent',
  components: {
    Question,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      eventObject: {},
      date: null,
      dateOccurred: null,
    }
  },
  computed: {
    ...mapState(['organizationDetails']),
  },
  methods: {
    onAnswerChanged(question) {
      if (question.answer.text) {
        this.$emit('fieldBlur')
      }
    },
    onDateOccuredChanged() {
      if (this.event.dateOccured) {
        this.$emit('fieldBlur')
      }
    },
    getEventDescription(event) {
      return utils.translateToCurrentLang(
        this.$language.current,
        event.categoryRef.descriptionHtmlEs,
        event.categoryRef.descriptionHtmlEn,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.event-details {
  width: 100%;
}
.date-picker {
  width: 100%;
  font-weight: bold;
  ::placeholder {
    font-weight: bold;
  }
}
.icon {
  height: 2rem;
  width: 3rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 1rem;
}
.event-header {
  display: flex;
  border-bottom: 1px solid $off-white;
  margin-bottom: 10px;
  width: 100%;
}
.question {
  margin-top: 10px;
}
.description {
  font-size: 15px;
  font-weight: 300;
}
.input-field {
  flex-direction: column;
}
.event-details-header {
  margin: 2rem auto;
  border-radius: 9px;
  padding: 14px;
  box-sizing: content-box;
  box-shadow: 0 4px 8px 0 #aaaaaa;
  background: var(--light-brand-color);
}
</style>
